import service from "@/service/request.js";
// 获取sts临时授权
export const getSecurityToken = (data) =>
  service({
    url: "/platform/oss/securityToken",
    method: "post",
    data,
    sign: true,
    saasToken: true,
    baseURL: process.env.VUE_APP_API,
  });

// 获取sts临时授权 case
export const getSecurityTokenCase = (data) =>
  service({
    url: "/platform/oss/securityNewToken",
    method: "post",
    data,
    sign: true,
    saasToken: true,
    baseURL: process.env.VUE_APP_API,
  });

// 获取sts临时授权(新)
export const getNewSecurityToken = (data) =>
  service({
    url: "/platform/oss/securityNewToken",
    method: "post",
    data,
    sign: true,
    saasToken: true,
    baseURL: process.env.VUE_APP_API,
  });
// 获取百度sts临时授权(新)
export const getStsToken = (data) =>
  service({
    url: "/ai-application/api/microModel/stsToken",
    method: "get",
    data,
    sign: true,
    saasToken: true,
    baseURL: process.env.VUE_APP_API,
  });


//火山引擎临时上传URL
export const PreSignedUrl = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/ai-application/api/microModel/PreSignedUrl",
  method: "post",
  data
});

//获取分享活动码
export const getMyEventCode = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/account-search/web/event/getMyEventCode",
  method: "post",
  data
});

//获取分享活动码
export const GetSaleId = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/member/User/GetSaleId",
  method: "post",
  data
});

//获取分享活动码
export const getCurrentUserInfo = data => service({
  aseURL: process.env.VUE_APP_API,
  url: "/user-service/user/getCurrentUserInfo",
  method: "post",
  data
});

// 获取阿波罗配置
export const getByKeys = (data) =>
  service({
    url: "/platform/basic/dict/getByKeys",
    method: "post",
    data,
    saasToken: true,
    baseURL: process.env.VUE_APP_API,
  });